<div class="rodo-container">
  <div class="rodo-content">
    <h2>Prywatność i ochrona danych (RODO)</h2>

    <div class="rodo-section">
      <h2>Usuwanie konta</h2>
      <p>Zgodnie z Rozporządzeniem Ogólnym o Ochronie Danych Osobowych (RODO), masz prawo do usunięcia swoich danych osobowych.</p>
      <p>Usunięcie konta spowoduje trwałe skasowanie wszystkich twoich danych z naszej aplikacji.</p>

      <button mat-raised-button color="warn" (click)="deleteAccount()" [disabled]="loading">
        @if (loading) {
          <span>Usuwanie...</span>
        }
        @if (!loading) {
          <span>Usuń moje konto</span>
        }
      </button>
    </div>
  </div>
</div>
